import { useState, useMemo } from 'react';
export function useTaskSearch(tasks) {
    const [search, setSearch] = useState('');
    const filteredTasks = useMemo(() => {
        if (!search.trim())
            return tasks;
        const lower = search.toLowerCase();
        return tasks.filter((t) => t.title.toLowerCase().includes(lower) ||
            t.id.toLowerCase().includes(lower) ||
            t.labels.some((l) => l.toLowerCase().includes(lower)));
    }, [tasks, search]);
    return { search, setSearch, filteredTasks };
}
export function useTaskFilter(tasks) {
    const [filters, setFilters] = useState({});
    const setFilter = (key, value) => {
        setFilters((prev) => ({ ...prev, [key]: value }));
    };
    const clearFilters = () => setFilters({});
    const filteredTasks = useMemo(() => {
        return tasks.filter((t) => {
            if (filters.status && t.status !== filters.status)
                return false;
            if (filters.priority && t.priority !== filters.priority)
                return false;
            if (filters.assignee && t.assignee !== filters.assignee)
                return false;
            if (filters.search) {
                const lower = filters.search.toLowerCase();
                if (!t.title.toLowerCase().includes(lower) &&
                    !t.id.toLowerCase().includes(lower))
                    return false;
            }
            return true;
        });
    }, [tasks, filters]);
    return { filters, setFilter, clearFilters, filteredTasks };
}
//# sourceMappingURL=useTasks.js.map